import { useState } from 'react'
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from 'react-router-dom';
import Opportunity from '../../models/Opportunity';
import { useOpportunity } from '../../providers/OpportunityProvider';
import { Radio, Input } from "antd";
import Form, { FormInputComponent } from "../../components/form/Form";
import LoadingBanner from '../../components/LoadingBanner';


const EXPECTATION_OPTIONS = {
    1: 'Far short of expectations',
    2: 'Short of expectations',
    3: 'Met expectations',
    4: 'Exceeded expectations',
    5: 'Greatly exceeded expectations'
}

const SATISFACTION_OPTIONS = {
    1: 'Very dissatisfied',
    2: 'Dissatisfied',
    3: 'Neither satisfied nor dissatisfied',
    4: 'Satisfied',
    5: 'Very satisfied'
}


const OppSurvey = () => {
    const { opportunity, isDisabled, isLoading } = useOpportunity();
    const navigate = useNavigate()

    const [formModel, setFormModel] = useState({
        satisfaction_score: null,
        expectation_score: null,
        recommend_score: null,
        notes: ''
    });


    const submitSatisfactionSurveyOppMutation = useMutation(['submitSatisfactionSurveyOpp', opportunity?.id],
        async data => {
            await TB.wait(1000)

            const formattedData = {
                satisfaction_score: Number(data.satisfaction_score),
                expectation_score: Number(data.expectation_score),
                recommend_score: Number(data.recommend_score),
                notes: data.notes,
            }

            console.log(formattedData, 'formattedData')

            const res = await Opportunity.submitSatisfactionSurveyOpp(opportunity.id, formattedData)

            console.log(res, 'res from backend')
            return res;
        },
        {
            onSuccess: async res => {
                console.log(res, 'eerrrsss')
                // TB.toast('Survey submitted successfully!', { type: 'success' });
                // closeSurveyModal()

                TB.alert("success", "Survey Submitted", "Thank you for your feedback", [{ title: 'Ok' }])

                return navigate('/talent/dashboard')
            },
            onError: async (e) => {
                console.log('onError', e)
                await TB.showServerErrorToast();
            }
        }
    )

    if (isLoading) {
        return <LoadingBanner message="Loading" adjustOverlay />;
    }

    return (
        <div className="bg-white max-w-[1140px] p-4 mx-auto mt-8">
            {/* <div className="bg-red-100 talent-opportunity-container p-4 m-auto"> */}
            <h2 className="pb-12 text-2xl">Survey for {opportunity?.project?.name}</h2>

            <Form
                title={null}
                subtitle={null}
                showRequired
                minimal
                submitButton={false}
                onSubmit={() => submitSatisfactionSurveyOppMutation.mutateAsync(formModel)}
                // onChange={model => setFormModel({ ...formModel, ...model })}
                onChange={setFormModel}
                model={formModel}
                fields={[]}
                isDisabled={isDisabled}
            >
                {/* {submitSatisfactionSurveyOppMutation.isLoading && <LoadingSpinner />} */}
                <div className="flex flex-col gap-6 pb-4">
                    <p className="text-base">
                        Based on your most recent project, please complete this quick survey to let us know how it went. If your project is still underway or has been extended, let us know how it's going.
                    </p>

                    <FormInputComponent
                        fieldName="satisfaction_score"
                        value={formModel.satisfaction_score}
                        label="1. Please rate your level of satisfaction with the upfront process to get your project ready for kick-off (talent matching, contracting, talent onboarding)."
                        type="antd-input"
                        required
                        className="!mb-0"
                    >
                        <Radio.Group
                            className="flex flex-wrap gap-4 p-3"
                            name="satisfaction_score"
                        >
                            {Object.keys(SATISFACTION_OPTIONS).map(v => {
                                return (
                                    <Radio key={v} value={v} className="text-xs flex-1">{SATISFACTION_OPTIONS[v]}</Radio>
                                )
                            })}
                        </Radio.Group>
                    </FormInputComponent>


                    <FormInputComponent
                        fieldName="expectation_score"
                        value={formModel.expectation_score}
                        label="2. Overall, how well did the project meet your expectations? If your project is still underway or has been extended, how well is it meeting your expectations?"
                        type="antd-input"
                        required
                        className="!mb-0"
                    >
                        <Radio.Group
                            className="flex flex-wrap gap-4 p-3"
                            name="expectation_score"
                        >
                            {Object.keys(EXPECTATION_OPTIONS).map(v => {
                                return (
                                    <Radio key={v} value={v} className="text-xs flex-1">{EXPECTATION_OPTIONS[v]}</Radio>
                                )
                            })}
                        </Radio.Group>
                    </FormInputComponent>


                    <FormInputComponent
                        fieldName="recommend_score"
                        value={formModel.recommend_score}
                        // label="3. How likely is it that you would recommend Wripple to a friend or colleague?"
                        label="3. On a scale of 0 to 10, where 0 means “not at all likely” and 10 means “extremely likely,” how likely is it that you would recommend Wripple to a friend of colleague?"
                        type="antd-input"
                        required
                        className="!mb-0"
                    >
                        <Radio.Group value={formModel.recommend_score} buttonStyle="solid" className="pt-3 flex flex-wrap">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                                <Radio.Button key={num} value={num} className="flex-1 text-center">{num}</Radio.Button>
                            ))}
                        </Radio.Group>

                    </FormInputComponent>

                    <FormInputComponent
                        fieldName="notes"
                        value={formModel.notes}
                        label="4. Please use the box below to provide any additional feedback you'd like to share about your experience."
                        placeholder="Enter your feedback here..."
                        type="antd-input"
                        required={false}
                        maxLength={2000}
                    >
                        <Input.TextArea rows={4} />
                    </FormInputComponent>

                    <div className="border-t pt-4">

                    </div>
                </div>

                <div className="flex gap-4 justify-end mt-6">
                    {/* <button
                        type="button"
                        className="btn btn-outline-primary"
                        disabled={isDisabled || submitSatisfactionSurveyOppMutation.isLoading}
                    // onClick={closeSurveyModal}
                    >
                        Cancel
                    </button> */}
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isDisabled || submitSatisfactionSurveyOppMutation.isLoading}
                    >
                        Submit Survey
                    </button>
                </div>
            </Form>
        </div>
    )
}

export default OppSurvey;
